/* eslint-disable guard-for-in */

export default {
    SET_FEATURE_FLAGS(state, featureFlags) {
        for (const flag in featureFlags) {
            state[flag] = featureFlags[flag];
        }
    },
};
